import { find, register } from '../../../../Javascript/Sysmex/Utils'

const OffcanvasContainer = el => {
  const burgerTrigger = find('[data-trigger]', el)
  const closeTrigger = find('.sysmexMoleculeOffcanvasContainer_close', el)
  const content = find('[data-content]', el)

  if (burgerTrigger) {
    burgerTrigger.addEventListener('click', toggle.bind(this, content), { passive: true })
  }
  if (closeTrigger) {
    closeTrigger.addEventListener('click', toggle.bind(this, content), { passive: true })
  }
}

const toggle = (contentContainer) => {
  contentContainer.classList.toggle('sysmexMoleculeOffcanvasContainer_active')
}

register('OffcanvasContainer', OffcanvasContainer)
